import { Vector } from "./vector";

export class Mouse {
	private static _left: boolean;
	private static _leftWas: boolean;
	private static _leftNext: boolean;
	private static _right: boolean;
	private static _rightWas: boolean;
	private static _rightNext: boolean;
	private static _position: Vector;
	private static _positionNext: Vector;

	public static x(): number {
		return this._position.x;
	}
	public static y(): number {
		return this._position.y;
	}
	public static position(): Vector {
		return new Vector(this._position.x, this._position.y);
	}
	public static absolute: Vector;

	public static left(): boolean {
		return this._left;
	}
	public static leftPressed(): boolean {
		return this._left && !this._leftWas;
	}
	public static leftReleased(): boolean {
		return !this._left && this._leftWas;
	}
	public static right(): boolean {
		return this._right;
	}
	public static rightPressed(): boolean {
		return this._right && !this._rightWas;
	}
	public static rightReleased(): boolean {
		return !this._right && this._rightWas;
	}

	public static init(): void {
		Mouse.absolute = new Vector(0, 0);
		Mouse._position = new Vector(0, 0);
		Mouse._positionNext = new Vector(0, 0);

		window.addEventListener("mousemove", (e) => {
			Mouse.absolute = new Vector(e.pageX, e.pageY);
		});

		window.addEventListener("mousedown", (e) => {
			if (e.button === 0) Mouse._leftNext = true;
			else Mouse._rightNext = true;
		});

		window.addEventListener("mouseup", (e) => {
			if (e.button === 0) Mouse._leftNext = false;
			else Mouse._rightNext = false;
		});
	}

	public static update(): void {
		this._leftWas = this._left;
		this._left = this._leftNext;
		this._rightWas = this._right;
		this._right = this._rightNext;

		/*
		// TODO:SOLVE THIS?
		// this doesn't work because the GameWindow.screenLeft/Top include the Window border
		// if there's a way to get the inner Left/Top then this would be super good as the mouse would
		// update even when out of the window bounds
		// alternatively could measure the difference when the mouse moves, and then use that ... but ugh that's gross
		if (Engine.client == Client.Desktop)
		{
			var screenMouse = GameWindow.screenMouse;
			screenMouse.x -= GameWindow.screenLeft;
			screenMouse.y -= GameWindow.screenTop;
			Mouse.setNextMouseTo(screenMouse.x, screenMouse.y);
		}
		*/

		this._position = this._positionNext;
	}
}
